import config from '@/config'

export const PAGE_CREATOR_SANDBOX = 'allow-scripts allow-same-origin'

export const PAGE_CREATOR_PRESENTATION_FIELDS = [
  'id',
  'version',
  'language',
  'fontFamily',
  'presenting',
  'sharePresentation',
  'sessionSince',
  'resetTimeStamp',
  'isBackstage',
  'isPresenterView',
  'isEditorView',
  'volume',
  'isEnableMusic',
  'isEnableSoundEffects',
  'isEnableQuizMusic',
  'uniqueAccessCode',
  'teamPlay',
  'teamScoringRule',
  'enableQuizCoundown',
  'areSlideOptionsShuffling',
  'audiencePacing',
  'manualRevealCorrectAnswers',
  'showHyperLink',
  'filteringProfanity',
]

export function isPageCreatorUrl(url, pageCreatorHost = config.pageCreatorHost) {
  if (!url || !pageCreatorHost) {
    return false
  }
  try {
    const zone = new URL(pageCreatorHost)
    const { protocol, host } = new URL(url)
    if (protocol !== zone.protocol || !host.endsWith(`.${zone.host}`)) {
      return false
    }
    const label = host.slice(0, -zone.host.length - 1)
    return /^[a-z0-9-]+$/.test(label)
  } catch (error) {
    return false
  }
}

export const PAGE_CREATOR_ZONES = ['https://page.ahaslides.io', 'https://page.staging.ahaslides.io']

export function isPageCreatorFrame(url) {
  return [config.pageCreatorHost, ...PAGE_CREATOR_ZONES].some((zone) => isPageCreatorUrl(url, zone))
}

export function isSlideBucket(bucket, slideId) {
  const prefix = `s${slideId}-v`
  return typeof bucket === 'string' && bucket.startsWith(prefix) && /^\d+\//.test(bucket.slice(prefix.length))
}

export const PAGE_CREATOR_AUDIENCE_FIELDS = [
  'audience',
  'audienceName',
  'audienceEmoji',
  'audienceTeam',
  'audienceTeamName',
  'audienceQuizTeam',
  'offline',
]

export const PAGE_CREATOR_TEXT_LIMIT = 300

export function pickFields(source, fields) {
  return Object.fromEntries(fields.filter((key) => key in (source || {})).map((key) => [key, source[key]]))
}

export function createCallBudget(limit, windowMs, now = Date.now) {
  const calls = []
  return () => {
    const time = now()
    while (calls.length > 0 && time - calls[0] >= windowMs) {
      calls.shift()
    }
    if (calls.length >= limit) {
      return false
    }
    calls.push(time)
    return true
  }
}
